module.exports = __webpack_public_path__ + "img/terroir-spiral-3.9f646290.jpg";